import Vue from 'vue';

export default {
    state:{
      temas:{
        imagen_default_tema:"https://firebasestorage.googleapis.com/v0/b/lmsv3-5ab3c.appspot.com/o/imagenes%2Fejemplo_tema_1.jpg?alt=media&token=dd434622-866b-4ee2-9c58-1a26bdc1596d"
      }
    },
    mutations: {
      
    },
    actions: { 
      compararContraHoy({},payload) {
        let dateNow = new Date();
        let year, month, day, hour, min, sec;
        year = dateNow.getFullYear();
        month = dateNow.getMonth() + 1;
        day = dateNow.getDate();
        hour = dateNow.getHours();
        min = dateNow.getMinutes();
        sec = dateNow.getSeconds();
        let arrNow = [year, month, day, hour, min, sec];
        let dateIni = payload.dateIni
        year = dateIni.getFullYear();
        month = dateIni.getMonth() + 1;
        day = dateIni.getDate();
        hour = dateIni.getHours();
        min = dateIni.getMinutes();
        sec = dateIni.getSeconds();
        let arrDateI = [year, month, day, hour, min, sec];
        let dateFin = payload.dateFin
        year = dateFin.getFullYear();
        month = dateFin.getMonth() + 1;
        day = dateFin.getDate();
        hour = dateFin.getHours();
        min = dateFin.getMinutes();
        sec = dateFin.getSeconds();
        let arrDateF = [year, month, day, hour, min, sec];
        for (let i = 0; i < arrDateI.length; i++) {
          if (arrNow[i] < arrDateI[i]) {
            return false;
          } else if (arrNow[i] > arrDateI[i]) {
            break;
          }
        }
  
        for (let i = 0; i < arrDateF.length; i++) {
          if (arrNow[i] > arrDateF[i]) {
            return false;
          } else if (arrNow[i] < arrDateF[i]) {
            break;
          }
        }
        return true;
      },
    },
    getters: {  
      getImagenDefaultTema(state){
        return state.temas.imagen_default_tema;
      }
    },
    
}


// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/modules/temas.js